/**
 * TS mirror of the CSS design tokens (global.css) for the few places that need a concrete color in
 * an imperative style object rather than a className: the tab bar tint, chart fills, icon tints and
 * native chrome. className styling stays the source of truth; this exists because React Navigation
 * styles and SVG props cannot read CSS variables.
 *
 * The table below is generated: `npm run tokens:apply` writes it from the same tokens that generate
 * `global.css`, so one token edit reskins web and native together. Edit
 * `design-system/tokens/tokens.json`, not this block.
 */
/* @tokens:start — GENERATED by `npm run tokens:apply` from design-system/tokens/tokens.json. */
export const palette = {
  light: {
    bg: "#eef1fb",
    surface: "#e0e3ee",
    foreground: "#202940",
    mutedForeground: "#4d5569",
    subtle: "#4d5569",
    primary: "#2148ca",
    primaryForeground: "#ffffff",
    border: "rgba(32,41,64,0.14)",
    gain: "#08633a",
    loss: "#a81f28",
    warning: "#765005",
  },
  dark: {
    bg: "#202940",
    surface: "#30394f",
    foreground: "#eef1fb",
    mutedForeground: "#c1c5d2",
    subtle: "#c1c5d2",
    primary: "#c3ff4d",
    primaryForeground: "#202940",
    border: "rgba(238,241,251,0.16)",
    gain: "#35d08a",
    loss: "#ff7070",
    warning: "#ffc44d",
  },
} as const;
/* @tokens:end */

export type ThemeName = keyof typeof palette;

/**
 * Fixed, theme-invariant navy for the few UI spots that must not follow light or dark: the scan
 * overlay pinned over a live camera feed, and dark text on the always-amber warning and offline
 * banner. Named once here so call sites do not retype the hex literal.
 */
export const FIXED_NAVY = "#17243f";

/** Fixed white ink over a live camera feed, where a theme token would follow the wrong ground. */
export const CAMERA_FOREGROUND = "#ffffff";
